var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolbarVip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.01 5.637a.75.75 0 01-.75-.75v-1.99a.75.75 0 011.5 0v1.99a.75.75 0 01-.75.75zm7.976-.05a.75.75 0 01-.75-.75V2.924a.75.75 0 011.5 0v1.913a.75.75 0 01-.75.75zM12.5 3.566h-5v1.5a1.5 1.5 0 01-3 0v-1.5a2 2 0 00-2 2V7.15h15V5.566a2 2 0 00-2-2v1.5a1.5 1.5 0 01-3 0v-1.5zm-10 12V8.4h15v7.166a2 2 0 01-2 2h-11a2 2 0 01-2-2z",
    fill: "url(#toolbar_vip_svg__paint0_linear_1348_67408)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.746 10.297a.75.75 0 010 1.06l-3.65 3.65a.75.75 0 01-1.06 0L7.01 12.985a.75.75 0 111.06-1.062l1.496 1.494 3.12-3.12a.75.75 0 011.06 0z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "toolbar_vip_svg__paint0_linear_1348_67408",
    x1: 7.348,
    y1: 4.298,
    x2: 12.133,
    y2: 17.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80B6F8"
  })))));
}
export default __webpack_public_path__ + "static/toolbar_vip.8786ea5a.svg";
export { SvgToolbarVip as ReactComponent };